export default __webpack_public_path__ + "static/media/Heart.672360b3.png";